var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDialer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 5.00024C12.1033 5.00024 13.0003 5.89724 13.0003 8.00024H15.0003C15.0003 4.77524 13.2253 3.00024 10.0003 3.00024V5.00024ZM13.4223 10.4432C13.2301 10.2686 12.9776 10.1754 12.7181 10.1835C12.4585 10.1915 12.2123 10.3001 12.0313 10.4862L9.63828 12.9472C9.06228 12.8372 7.90428 12.4762 6.71228 11.2872C5.52028 10.0942 5.15928 8.93324 5.05228 8.36124L7.51128 5.96724C7.69769 5.78637 7.80642 5.54006 7.81444 5.28045C7.82247 5.02083 7.72917 4.76828 7.55428 4.57624L3.85928 0.513239C3.68432 0.320596 3.44116 0.203743 3.18143 0.187499C2.92171 0.171254 2.66588 0.256897 2.46828 0.426239L0.298282 2.28724C0.125393 2.46075 0.0222015 2.69169 0.00828196 2.93624C-0.00671804 3.18624 -0.292718 9.10824 4.29928 13.7022C8.30528 17.7072 13.3233 18.0002 14.7053 18.0002C14.9073 18.0002 15.0313 17.9942 15.0643 17.9922C15.3088 17.9786 15.5396 17.8749 15.7123 17.7012L17.5723 15.5302C17.7417 15.3328 17.8276 15.077 17.8115 14.8173C17.7954 14.5576 17.6788 14.3143 17.4863 14.1392L13.4223 10.4432Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialer);
export default __webpack_public_path__ + "static/media/Dialer.271d87a7389164ce1f923a0a115e403a.svg";
export { ForwardRef as ReactComponent };